(function() {
  function isIos() {
    var ua = navigator.userAgent || navigator.vendor || '';
    return (/iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream;
  }

  function call(method, parameter, options) {
    var opts = options || {};
    var callbackName = opts.callbackName || method + 'Callback';
    var needCallback = opts.needCallback !== false;
    var paramStr = typeof parameter === 'string' ? parameter : (parameter == null ? '' : JSON.stringify(parameter));

    function resultParser(val) {
      if (typeof val !== 'string') return val;
      try { return JSON.parse(val); } catch (e) { return val; }
    }

    if (needCallback) {
      return new Promise(function(resolve, reject) {
        var cbName = callbackName;
        if (typeof hanntoJsBridge !== 'undefined' && hanntoJsBridge.postMessage) cbName = callbackName + 'Flutter';
        window[cbName] = function(data) {
          try {
            var parsed = resultParser(data);
            if (parsed && typeof parsed === 'object' && 'code' in parsed) {
              parsed.code === 0 ? resolve(parsed) : reject(parsed);
            } else {
              resolve(parsed);
            }
          } catch (e) {
            reject({ code: -1, message: '解析数据失败', error: e });
          }
        };
        if (typeof hanntoJsBridge !== 'undefined' && hanntoJsBridge.postMessage) {
          hanntoJsBridge.postMessage(JSON.stringify({ params: paramStr, method: method }));
          return;
        }
        if (isIos()) {
          if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.hanntoJsBridge) {
            window.webkit.messageHandlers.hanntoJsBridge.postMessage({ parameter: paramStr, method: method });
          } else {
            reject({ code: -1, message: 'iOS JSBridge未定义' });
          }
        } else {
          if (typeof hanntoJsBridge === 'undefined') { reject({ code: -1, message: 'hanntoJsBridge未定义' }); return; }
          var fn = hanntoJsBridge[method];
          if (typeof fn !== 'function') { reject({ code: -1, message: '方法 ' + method + ' 不存在' }); return; }
          try {
            var ret = fn.call(hanntoJsBridge, paramStr);
            if (ret != null) {
              var p = typeof ret === 'string' ? resultParser(ret) : ret;
              if (p && typeof p === 'object' && 'code' in p) p.code === 0 ? resolve(p) : reject(p);
              else resolve(p);
            }
          } catch (e) {
            reject({ code: -1, message: '调用方法 ' + method + ' 失败', error: e });
          }
        }
      });
    }
    if (isIos()) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.hanntoJsBridge) {
        window.webkit.messageHandlers.hanntoJsBridge.postMessage({ parameter: paramStr, method: method });
      }
    } else {
      if (typeof hanntoJsBridge === 'undefined') throw new Error('hanntoJsBridge未定义');
      var m = hanntoJsBridge[method];
      if (typeof m !== 'function') throw new Error('方法 ' + method + ' 不存在');
      var r = m.call(hanntoJsBridge, paramStr);
      return typeof r === 'string' && r ? (function() { try { return JSON.parse(r); } catch (e) { return r; } })() : r;
    }
  }

  window.HanntoJsBridge = {
    getSignature: function(params) { return call('getSignature', params, { callbackName: 'getSignatureCallback', needCallback: true }); },
    close: function(params) { return call('close', params, { callbackName: 'close', needCallback: true }); },
    trackEvent: function(params) { return call('trackEvent', params, { callbackName: 'trackEvent', needCallback: true }); },
    navigateToFlutter: function(params) { return call('navigateToFlutter', params, { callbackName: 'navigateToFlutter', needCallback: true }); },
    getDeviceInfo: function(params) { return call('getDeviceInfo', params, { callbackName: 'getDeviceInfoCallback', needCallback: true }); },
    getWebViewSource: function(params) { return call('getWebViewSource', params, { callbackName: 'getWebViewSourceCallback', needCallback: true }); },
    saveRecipe: function(params) { return call('saveRecipe', params, { callbackName: 'saveRecipeCallback', needCallback: true }); },
    useRecipe: function(params) { return call('useRecipe', params, { callbackName: 'useRecipeCallback', needCallback: true }); },
    shareRecipe: function(params) { return call('shareRecipe', params, { callbackName: 'shareRecipeCallback', needCallback: true }); }
  };
})();
